<script setup lang="ts">
import { customElementPropsKey } from '@/types/customElementProps.types'
import { computed, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useRealmSettings } from '@/stores/useRealmSettings'
import { useI18n } from 'vue-i18n'
import PageTitle from '@/components/PageTitle.vue'

const templateProps = inject(customElementPropsKey)
const { realmSettings } = storeToRefs(useRealmSettings())
const { t } = useI18n()

const mailToLink = computed(() => {
  const subject = encodeURIComponent(
    t('vue.error-page.mail-to-button.subject', {
      network: realmSettings.value?.metadata.realm_name,
    }),
  )
  const body = encodeURIComponent(
    t('vue.error-page.mail-to-button.body', {
      url: templateProps?.baseUrl,
      error: templateProps?.errorMessage,
    }),
  )
  return `mailto:?subject=${subject}&body=${body}`
})
</script>

<template>
  <div>
    <PageTitle
      :title="$t('error-page.generic.title')"
      :hide-generic-message="true"
    />
    <div class="d-flex flex-column gap-4">
      <p class="text-center">{{ $t(templateProps?.errorMessage ?? '') }}</p>
      <v-btn :href="templateProps?.errorActionUrl || templateProps?.loginUrl">{{
        $t('error-page.back.button')
      }}</v-btn>
      <v-btn variant="text" :href="mailToLink" target="_blank">{{
        $t('error-page.contact.button')
      }}</v-btn>
    </div>
  </div>
</template>
